import Vue from "vue";
import Component from "vue-class-component";
import SidebarComponent from "@/components/sidebar/sidebar.component.vue";
import HeaderComponent from "@/components/header/header.component.vue";
import LoaderComponent from "@/components/loader/loader.component.vue";
import ModalPermissionsComponent from "@/components/modal-permissions/modal-permissions.component.vue";
import ModalLoginComponent from "@/components/modal-login/modal-login.component.vue";
// External components
import Datepicker from "vuejs-datepicker";
// Services
import CandidateService from "@/core/services/candidate.service";
import SidebarService from "@/core/services/sidebar.service";

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    LoaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    Datepicker,
  },
})
export default class EvaluatedComponent extends Vue {
  // Service's Instance
  public candidateService: any = new CandidateService();
  public sidebarService: any = new SidebarService();
  public isLoading: boolean = false;

  // Modals
  public logInModal: boolean = false;
  public modal: boolean = false;
  public showModal: boolean = false;
  public showReportModal: boolean = false;

  public deleteIcon: boolean = false;
  public nextPositionDisabled: boolean = false;
  public previousPositionDisabled: boolean = true;
  public pagination: boolean = true;
  public userToDelete: any;
  public searchFlag: any = [];
  public searchFlagYear: any = [];
  public candidateList: any = [];
  public filterCandidateList: any = [];
  public companyList: any = [];
  public search: string = "";
  public searchYear: string = "";
  public companies: string = "";
  public surveys: string = "";
  public finderCompanies: string = "default";
  public searchByDate: any = "";
  public createdAt: string = "";
  public progress: string = "";
  public filterConcatDate: string = "";
  public companyToSearch: string = "";
  public pageOffset: number = 0;
  public itemsPerPage: number = 10;
  public totalPages: number = 0;
  public currentPage: number = 1;
  public nextPage: number = 2;
  public totalOfEvaluated: number = 0;
  public itemsOfFrom: number = 0;
  public itemsOfTo: number = 0;
  public isTrainingSuperAdmin: boolean = false;
  public isAdminCfeRole: boolean = false;
  public isReporterCfeRole: boolean = false;
  public filterBySurvey: number = 0;
  public searchBySurveyFlag: boolean = false;
  public evaluationsEnd: Array<any> = [];
  public totalEvaluations: number = 0;
  public areCandidatesReadyToShow: boolean = false;
  private searchTimeoutId: any;
  public name: string = "";
  public surname: string = "";
  public email: string = "";
  public company: string = "";
  // Reports variables
  public selectedCompanyCandidatesEndedUp: string = "";
  public reportStartDate: string = "";
  public reportEndDate: string = "";
  public reportType: "finished" | "created";
  public monthlyReportError: boolean = false;

  mounted() {
    const _ = this;
    _.isTrainingAdmin();
    _.checkCfeRoles();
    _.get(_.pageOffset, _.itemsPerPage);
    _.filterDate();
    _.getCompanies();
  }

  filterByDate() {
    const _ = this;
    _.deleteIcon = true;
    let day =
      _.searchByDate.getDate() < 10
        ? "0" + _.searchByDate.getDate()
        : _.searchByDate.getDate();
    let month =
      _.searchByDate.getMonth() < 10
        ? "0" + (_.searchByDate.getMonth() + 1)
        : _.searchByDate.getMonth() + 1;
    let year = _.searchByDate.getFullYear();
    _.filterConcatDate = `${year}-${month}-${day}`;
    if (_.finderCompanies == "default") {
      _.filterCandidateList = _.candidateList.filter((candidate) => {
        let parseDate: any = candidate.createdAt.split("T");
        parseDate = parseDate[0];
        return _.filterConcatDate == parseDate;
      });
      return;
    }
    _.filterCandidateList = _.candidateList.filter((candidate) => {
      let parseDate: any = candidate.createdAt.split("T");
      parseDate = parseDate[0];
      return (
        candidate.company.name == _.finderCompanies &&
        _.filterConcatDate == parseDate
      );
    });
  }

  getCompletedSurveysTotal() {
    this.candidateService
      .getCompletedSurveys()
      .then((response) => {
        this.evaluationsEnd = response.data.users;
      })
      .catch((err) => console.log(err));
  }

  deleteDate() {
    const _ = this;
    _.filterConcatDate = "";
    _.deleteIcon = false;
    if (_.filterConcatDate == "") {
      _.searchByDate = "";
      _.filterCandidateList = _.candidateList;
      return;
    }
  }

  fiterByCompany(company: any) {
    const _ = this;
    if (company == "default" && _.filterConcatDate == "") {
      _.filterCandidateList = _.candidateList;
      return;
    }

    if (company == "default" && _.filterConcatDate != "") {
      _.filterCandidateList = _.candidateList.filter((candidate) => {
        let parseDate: any = candidate.createdAt.split("T");
        parseDate = parseDate[0];
        return _.filterConcatDate == parseDate;
      });
      return;
    }

    if (_.filterConcatDate != "") {
      _.filterCandidateList = _.candidateList.filter((candidate) => {
        let parseDate: any = candidate.createdAt.split("T");
        parseDate = parseDate[0];
        return (
          candidate.company.name == company && _.filterConcatDate == parseDate
        );
      });
      return;
    }
    _.filterCandidateList = _.candidateList.filter((candidate: any) => {
      return candidate.company.name == company;
    });
  }

  filterDate(date: any = "") {
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  fixed(progress: number) {
    const _ = this;
    progress = progress.toFixed(0);
    return progress;
  }

  openModal(id: string) {
    const _ = this;
    _.userToDelete = id;
    _.modal = true;
  }

  getCompanies() {
    const _ = this;
    _.isLoading = true;
    _.candidateService
      .getCompanies()
      .then((data: any) => {
        _.companyList = data["data"].companies;
        _.companyList.sort(function (a, b) {
          var textA = a.name.toLowerCase();
          var textB = b.name.toLowerCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        _.isLoading = false;
      });
  }

  saveSurveyPercentages(surveys: any) {
    const _ = this;
    sessionStorage.setItem("personalStylePercentage", surveys[0].progress);
    sessionStorage.setItem("communicationStylePercentage", surveys[1].progress);
    sessionStorage.setItem("mapPercentage", surveys[2].progress);
  }

  public searchByFilter() {
    // Cancel the previous timeout if it exists
    if (this.searchTimeoutId) {
      clearTimeout(this.searchTimeoutId);
    }

    // Set a new timeout to wait for 1.5 seconds before making the request
    this.searchTimeoutId = setTimeout(() => {
      this.searchByFiltersRequest();
    }, 800);
  }

  public searchByFiltersRequest(pageOffset = 0, itemsPerPage = 10000) {
    const noFilterApplied =
      !this.name && !this.surname && !this.email && !this.company;

    if (noFilterApplied) {
      this.get();
      return;
    }

    const filtersToApply = {
      name: this.name,
      surname: this.surname,
      email: this.email,
      company_id: this.company,
    };

    console.log(filtersToApply, " to send?");

    this.candidateService
      .get(pageOffset, itemsPerPage, filtersToApply)
      .then((data: any) => {
        this.totalOfEvaluated = data["data"].total;
        this.candidateList = data["data"].users;
        this.filterCandidateList = data["data"].users;
        this.currentPage = 1;
      });
  }

  public get(pageOffset = 0, itemsPerPage = 10) {
    const _ = this;
    _.isLoading = true;
    _.candidateService
      .get(pageOffset, itemsPerPage)
      .then((data: any) => {
        _.totalOfEvaluated = data["data"].total;
        if (this.areCandidatesReadyToShow) {
          _.totalEvaluations = data["data"].total;
          _.candidateList = data["data"].users;
          _.filterCandidateList = data["data"].users;
          _.totalPages = Math.ceil(_.totalOfEvaluated / itemsPerPage);
          if (_.totalPages <= 1) {
            _.pagination = false;
          }
          if (pageOffset == 0) {
            _.itemsOfFrom = 1;
            _.itemsOfTo = _.candidateList.length;
            _.previousPositionDisabled = true;
          }
          if (pageOffset != 0) {
            _.previousPositionDisabled = false;
          }
          if (pageOffset == _.totalPages - 1) {
            _.itemsOfTo = _.totalOfEvaluated;
          }
          // _.getCompletedSurveysTotal();
          setTimeout(() => {
            _.isLoading = false;
          }, 2000);
          return;
        }
        this.areCandidatesReadyToShow = true;

        let pageToInit: number | string = (
          _.totalOfEvaluated / itemsPerPage
        ).toString();
        const lastPageItems = _.totalOfEvaluated % itemsPerPage;

        if (lastPageItems === 0) {
          pageToInit = +pageToInit - 1;
          pageToInit = pageToInit.toString();
        }

        this.get(parseInt(pageToInit), itemsPerPage);
        _.pageOffset = parseInt(pageToInit);
      })
      .catch((err: any) => {
        if (err.response.data.message.includes("Invalid or inexistent user")) {
          localStorage.removeItem("tk_auth");
          _.logInModal = true;
        }
        setTimeout(() => {
          _.isLoading = false;
        }, 2000);
      });
  }

  closeSidebar() {
    const _ = this;
    _.sidebarService.close();
  }

  delete_user() {
    const _ = this;
    _.isLoading = true;
    _.candidateService
      .delete_user(_.userToDelete)
      .then((data: any) => {
        _.get();
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        setTimeout(() => {
          _.isLoading = false;
        }, 2000);
      });
  }

  nextPageAction() {
    const _ = this;
    if (this.currentPage === 1) {
      return;
    }
    _.itemsOfTo = _.itemsOfTo + _.candidateList.length;
    _.itemsOfFrom = _.itemsOfFrom + _.candidateList.length;
    _.pageOffset++;
    _.currentPage--;
    _.nextPage++;
    _.get(_.pageOffset);

    if (_.totalPages == _.currentPage) {
      _.nextPositionDisabled = true;
      return;
    }
  }

  previousPageAction() {
    const _ = this;
    if (this.currentPage === this.totalPages) {
      return;
    }
    _.itemsOfTo = _.itemsOfTo - _.candidateList.length;
    _.itemsOfFrom = _.itemsOfFrom - _.candidateList.length;
    _.pageOffset--;
    _.currentPage++;
    _.nextPage--;
    _.get(_.pageOffset);

    if (_.totalPages != _.currentPage) {
      _.nextPositionDisabled = false;
      return;
    }
  }

  private isTrainingAdmin() {
    const _ = this;
    const companyId = localStorage.getItem("company");
    if (companyId === "null" || companyId === "1") {
      _.isTrainingSuperAdmin = true;
    }
  }

  private checkCfeRoles() {
    const _ = this;
    const role = localStorage.getItem("role");
    _.isAdminCfeRole = role === "5";
    _.isReporterCfeRole = role === "6";
  }

  public percentageByEvaluated(surveys) {
    const surveyOne = surveys[0] ? surveys[0].progress : 0;
    const surveyTwo = surveys[1] ? surveys[1].progress : 0;
    const surveyThree = surveys[2] ? surveys[2].progress : 0;

    const surveyOneReal = (surveyOne * 10) / 100;
    const surveyTwoReal = (surveyTwo * 10) / 100;
    const surveyThreeReal = (surveyThree * 80) / 100;
    const result = surveyOneReal + surveyTwoReal + surveyThreeReal;

    const roundedResult = +result.toFixed(0) === 99 ? 100 : result.toFixed(0);

    return roundedResult;
  }

  public downloadMonthlyReport() {
    this.showReportModal = true;
  }

  public downloadReport() {
    this.isLoading = true;
    this.monthlyReportError = false;

    const companyId = this.selectedCompanyCandidatesEndedUp;
    const startDate = this.reportStartDate;
    const endDate = this.reportEndDate;
    const reportType = this.reportType || "finished";
    this.candidateService
      .downloadMonthlyReport(companyId, startDate, endDate, reportType)
      .then((response) => {
        this.isLoading = false;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "reporte_mensual.xlsx");
        document.body.appendChild(link);
        link.click();
        this.showReportModal = false;
      })
      .catch((error) => {
        this.isLoading = false;
        this.monthlyReportError = true;
        console.log(error);
      });
  }
}
